import React, { createContext, useContext } from "react";
import useActivityScroll from "@/modules/lead-page/new/hooks/activity-scroll.hook";

interface ActivityScrollContextType {
  containerRef:
    | React.RefObject<HTMLDivElement>
    | ((node: HTMLDivElement | null) => void);
  containerEl: HTMLDivElement | null;
  loaderTopRef:
    | React.RefObject<HTMLDivElement>
    | ((node: HTMLDivElement | null) => void);
  loaderBottomRef:
    | React.RefObject<HTMLDivElement>
    | ((node: HTMLDivElement | null) => void);
  scrollToBottom: () => void;
  scrollToBottomWithRefresh: () => void;
  showScrollToBottom: boolean;
}

const ActivityScrollContext = createContext<
  ActivityScrollContextType | undefined
>(undefined);

export const ActivityScrollProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const {
    containerRef,
    containerEl,
    loaderTopRef,
    loaderBottomRef,
    scrollToBottom,
    scrollToBottomWithRefresh,
    showScrollToBottom,
  } = useActivityScroll();

  return (
    <ActivityScrollContext.Provider
      value={{
        containerRef,
        containerEl,
        loaderTopRef,
        loaderBottomRef,
        scrollToBottom,
        scrollToBottomWithRefresh,
        showScrollToBottom,
      }}
    >
      {children}
    </ActivityScrollContext.Provider>
  );
};

export const useActivityScrollContext = () => {
  const context = useContext(ActivityScrollContext);
  if (!context) {
    throw new Error(
      "useActivityScrollContext must be used within an ActivityScrollProvider"
    );
  }
  return context;
};
